const statusType = Object.freeze({
  Completed: "Completed",
  Open: "Open",
  Closed: "Closed",
  InReview: "InReview",
  RevertToApplicant: "RevertToApplicant",
  SendEmailToEmployer: "SendEmailToEmployer",
});

export default statusType;